import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="member-sector-toggle"
export default class extends Controller {
  static targets = ["checkbox", "container"];

  connect() {
    this.toggle();
  }

  toggle() {
    if (!this.hasContainerTarget) return;

    const isMember = this.hasCheckboxTarget && this.checkboxTarget.checked;
    this.containerTargets.forEach((el) => el.classList.toggle("hidden", !isMember));
  }
}
